export default "/_next/static/images/d6bf2b8b07f495d6136c98342e33c9fd.jpg";